<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler v-if="$store.state.user">
      <CHeaderNavLink>
        <div class="c-avatar">
          <CIcon name="cil-user"></CIcon>
        </div>
        {{ $store.state.user.name }}
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Conta</strong>
    </CDropdownHeader>
    <CDropdownItem @click.prevent="$router.push('/profile')">
      <CIcon name="cil-user" /> Editar perfil
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click.prevent="logout()">
      <CIcon name="cil-lock-locked"/> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      itemsCount: 42
    }
  },
  methods: {
    logout: function() {
      const self = this
      self.$store.commit('setJwtToken', null)
      self.$store.commit('setUser', null)
      self.$store.commit('setNavigationRoutes', [])

      self.$cookie.set('token', null, {
        expires: -1,
        domain: 'voudetrip.com.br'
      })

      self.$router.push('/pages/login')
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
